import { CAMPOS_WHATSAPP_CAMPANA, faltaWhatsappCampana, whatsappDeVenue } from "../recordatorios/recordatorios";

/* Form values and rules of the client campaigns (Clientes > Campañas). The server owns the defaults: a campaign the
   local never saved comes back with them, so the form only normalizes what it receives. */

export const TIPOS = ["birthday", "winback"];
export const MAX_TEXTO = 1000;
export const MAX_ASUNTO = 150;
export const MAX_IMAGENES = 3;
export const MAX_IMAGEN_BYTES = 2 * 1024 * 1024;
export const TIPOS_IMAGEN = ["image/jpeg", "image/png", "image/webp", "image/gif"];
export const DIAS_ANTES = [0, 1, 2, 3, 4, 5, 6, 7];
export const DIAS_SIN_VENIR = [30, 60, 90];
export const HORAS = Array.from({ length: 24 }, (_, h) => ({ value: h, label: `${String(h).padStart(2, "0")}:00` }));

/** Form value from a server campaign. */
export const campanaAForm = (c = {}) => ({
  type: c.type,
  enabled: c.enabled === true,
  sendHour: Number.isInteger(Number(c.sendHour)) && c.sendHour !== null && c.sendHour !== "" ? Number(c.sendHour) : 10,
  daysBefore: DIAS_ANTES.includes(Number(c.daysBefore)) ? Number(c.daysBefore) : 0,
  inactiveDays: DIAS_SIN_VENIR.includes(Number(c.inactiveDays)) ? Number(c.inactiveDays) : 60,
  email: { enabled: c.email?.enabled !== false, subject: c.email?.subject || "", body: c.email?.body || "",
    images: (Array.isArray(c.email?.images) ? c.email.images : [])
      .filter((i) => i?.url)
      .slice(0, MAX_IMAGENES)
      .map((i) => ({ url: i.url, alt: i.alt || "" })),
  },
  whatsapp: whatsappDeVenue(c.whatsapp, CAMPOS_WHATSAPP_CAMPANA),
});

/** Body of PUT /campaigns/:type. The `bloqueo` the WhatsApp box keeps in the form is never sent. */
export const formACampana = (f) => {
  const wa = f.whatsapp;
  return {
    enabled: Boolean(f.enabled),
    sendHour: f.sendHour,
    ...(f.type === "birthday" ? { daysBefore: f.daysBefore } : { inactiveDays: f.inactiveDays }),
    email: { enabled: Boolean(f.email.enabled), subject: f.email.subject.trim(), body: f.email.body.trim(),
      images: f.email.images.map((i) => ({ url: i.url, alt: (i.alt || "").trim() })),
    },
    whatsapp: {
      enabled: Boolean(wa.enabled),
      workspaceId: wa.workspaceId || "",
      templateName: wa.templateName || "",
      language: wa.language,
      parameters: wa.parameters || [],
    },
  };
};

/** Why the campaign can't be saved, or "" when it can. Only an active campaign is validated, and only its enabled channels. */
export const faltaCampana = (f) => {
  if (!f.enabled) return "";
  if (!f.email.enabled && !f.whatsapp.enabled) return "Activá al menos un canal: email o WhatsApp.";
  if (f.email.enabled) {
    if (!f.email.subject.trim()) return "Escribí el asunto del email.";
    if (!f.email.body.trim()) return "Escribí el texto del email.";
    if (f.email.body.length > MAX_TEXTO) return `El texto del email admite hasta ${MAX_TEXTO} caracteres.`;
  }
  return faltaWhatsappCampana(f.whatsapp);
};

/** Why the file can't be uploaded as a mail image, or "" when it can. */
export const faltaImagen = (file) => {
  if (!TIPOS_IMAGEN.includes(file?.type)) return "La imagen debe ser JPG, PNG, WEBP o GIF.";
  if (file.size > MAX_IMAGEN_BYTES) return "La imagen pesa más de 2 MB. Elegí una más liviana.";
  return "";
};

/** Moves the image at `index` by `delta` places; returns the same list when it can't move. */
export const moverImagen = (images, index, delta) => {
  const to = index + delta;
  if (to < 0 || to >= images.length) return images;
  const copia = [...images];
  [copia[index], copia[to]] = [copia[to], copia[index]];
  return copia;
};
